export default __webpack_public_path__ + "static/media/userqn_wedding.532bc41b.svg";